<template>
  <div id="campaign">
    <div v-if="!loading">
      <section :class="{ 'fade-base': true, 'fade': pageFade }">
        <div class="c-campaign bg-white">
          <!-- list new -->
          <ul class="c-list-deal c-list-deal--xl has-full">
              <li>
                  <div class="c-list-deal__item">
                    <viewImage
                      type="campaign"
                      :img="campaign.image"
                    />
                    <div class="mt-13">
                      <b>{{ campaign.title }}</b>
                      <div class="c-list-deal__info--head color-5 mt-8 font-size-12">
                        <expirationDate
                          size="xl"
                          type="campaign"
                          :unlimited="false"
                          :availableFrom="campaign.lotteryStartAt"
                          :availableTo="campaign.lotteryEndAt"
                          :isEntered="isLotteryEntered"
                          :isEnded="campaign.isEnded"
                        />
                      </div>
                      
                      <div v-if="isLotteryEntered" class="c-campaign__entered">
                        <h3 class="text-center">抽選済み</h3>
                        <template v-if="getLotteryResult() == 1">
                          <div class="campaign__entered-box">
                            <div>抽選結果</div>
                            <div class="title-win">当たり</div>
                          </div>
                          <p class="text-center">
                            <router-link :to="`/coupons?category=LotteryCoupon`" class="color-5 decoration-none">
                              クーポン一覧
                            </router-link>
                            をご確認ください
                          </p>
                        </template>
                        <template v-else-if="getLotteryResult() == 2">
                          <div class="campaign__entered-box">
                            <div>抽選結果</div>
                            <div class="title-lost">はずれ</div>
                          </div>
                        </template>
                      </div>

                      <div class="c-list-deal__info--content">
                        <div v-html="autolink(campaign.content)"></div>
                      </div>
                    </div>
                  </div>
              </li>
          </ul>
          <div class="c-campaign__conditions" v-if="isLotteryEntered || campaign.conditions || !isUserLoggedIn()">
            <div class="l-search__title c-campaign__conditions_box">参加条件</div>
            <div class="p-5" v-html="autolink(campaign.conditions) "></div>
          </div>
          <div class="color-8 mb-32 mt-24">
            <span v-if="isLotteryEntered" class="mt-24">※当選したアプリクーポンは次回お会計からご利用となります。</span>
          </div>
        </div>
        <template v-if="!isProcessing">
          <div class="btn-fixed-bottom" v-if="entryBtnStatus != 'entered'">
            <button v-if="entryBtnStatus == 'out'" class="center-all-item btn-to-site border-0 c-btn--disabled" disabled>
              抽選期間外
            </button>
            <button v-else-if="entryBtnStatus == 'ended'" class="center-all-item btn-to-site border-0 c-btn--disabled" disabled>
              予定本数は終了しました
            </button>
            <router-link v-else-if="entryBtnStatus == 'guest'" to="/account/profile" class="bg-purple center-all-item btn-to-site decoration-none">アカウント連携する</router-link>
            <button v-else-if="entryBtnStatus == 'possible'" class="bg-purple center-all-item btn-to-site border-0" v-bind:class="{ disabled: isLoad }" @click="nextPage" >
              抽選する
            </button>
            <p v-if="!isUserLoggedIn()" class="color-5 font-size-11">抽選に参加するにはアカウント連携が必要です</p>
          </div>
        </template>
      </section>
      <div id="coupon-detail-popup" class="l-shop l-shop--detail l-shop-overlay fixed" v-if="showCouponModal" style=" z-index: 201;">
        <div class="l-list-coupon l-list-coupon--detail p-0 fixed" style="width: calc(100% - 30px);max-height: calc(100vh - 60px);">
          <div class="l-main__head--control l-main__head--control--close" @click="closeCouponModal">
            <img src="/assets/images/icon/icon-close-black.svg" alt="" />
          </div>
          <div class="c-coupon c-coupon-have-name">
            <viewImage
              type="coupon"
              :img="couponDetail.image"
            />
            <div class="c-coupon__bot">
              <div class="c-coupon__time color-4">
                <expirationDate
                  type="coupon"
                  size="xl"
                  :unlimited="couponDetail.unlimited"
                  :availableFrom="couponDetail.availableFrom"
                  :availableTo="couponDetail.availableTo"
                />
              </div>
              <div class="c-coupon__content">                
                <h1 class="c-coupon__content--not-bold">
                  <div v-html="autolink(couponDetail.guide)"></div>
                </h1>
                <div v-html="autolink(couponDetail.notice) "></div>
                <div v-if="couponDetail.winnersUnlimited" class="c-campaign__coupon__quantity" style="width:100%">数量:無制限</div>
                <div v-else class="c-campaign__coupon__quantity" style="width:100%">数量限定:{{ couponDetail.winnersNumber }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader :loading="loading" />
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getShop, getCampaignDetail, isLotteryEntered, getLotteryEnteredData, getUser } from "../store/firestore.js";
import viewImage from "../components/parts/viewImage.vue"
import expirationDate from "../components/parts/expirationDate.vue"
import firebase from "../common/firebaseProject";
import loader from "../components/parts/loader.vue"

export default Vue.extend({
  name: "CampaignDetail",
  components: {
    viewImage,
    expirationDate,
    loader
  },
  props: {
    campaignId: {
      type: String,
      required: true
    }
  },
  mixins: [Tenant],
  data() {
    return {
      shop: {},
      campaign: {},
      showCouponModal: false,
      couponDetail: null,
      couponsList: [],
      isLotteryEntered: false,
      isProcessing: true,
      campaignResultList: {},
      isLoad: false,
      loading: false
    }
  },
  watch: {
    campaignId: {
      handler: async function (newVal) {
        this.loading = true;
        if (newVal) await this.getCampaignData(newVal)
        this.loading = false;
      },
      immediate: true
    }
  },
  computed: {
    entryBtnStatus: function () {
      if (
        (this.campaign.lotteryStartAt && this.campaign.lotteryStartAt > Date.now()) ||
        (this.campaign.lotteryEndAt && this.campaign.lotteryEndAt < Date.now())
      ) {
        // 期間外
        return 'out'
      }
      if (this.campaign.isEnded) {
        // 予定数終了
        return 'ended'
      }
      if (!this.isUserLoggedIn()) {
        // 未ログイン
        return 'guest'
      }
      if (this.isLotteryEntered) {
        // 抽選済み
        return 'entered'
      }
      // 抽選可能
      return 'possible'
    }
  },
  mounted() {
    Common.initDom();
  },
  updated() {
    this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    async getCampaignData(id) {
      this.campaign = await getCampaignDetail(id);
      if (!this.campaign) {
        this.$router.push('/campaign/list');
      }
      this.shop = await getShop(this.SHOP_ID);
      if (this.isUserLoggedIn()) {
        this.isLotteryEntered = this.campaign.codeType == 2 ? false : await isLotteryEntered(this.SHOP_ID, id, this.$store.state.userId);

        this.campaignResultList = await getLotteryEnteredData(this.SHOP_ID, id, this.$store.state.userId);
      }
      this.campaign.content = Common.addExtLink(this.campaign.content);
      this.campaign.conditions = Common.addExtLink(this.campaign.conditions);
      this.isProcessing = false;
    },
    closeCouponModal() {
      this.showCouponModal = false;
      this.couponDetail = {};
    },
    checkCode() {
      if (this.campaign) {
        if (this.campaign?.codeType && this.campaign.codeType != 0) {
          return true
        }
      }
      return false
    },
    async nextPage() {
      if (this.isLoad) return false
      this.isLoad = true
      try {
        // 最新の状態を確認する
        let campaign = await getCampaignDetail(this.campaignId);

        let isEntered = campaign.codeType == 2 ? false : await isLotteryEntered(this.SHOP_ID, this.campaignId, this.$store.state.userId);
        if (campaign.isEnded) {
          await this.confirm('予定本数は終了しました', true);
          this.$router.push(`/campaign/list`);
        } else if (isEntered) {
          await this.confirm('抽選済みです', true);
          this.$router.push(`/campaign/list`);
        } else {
          if (this.checkCode()) {
            //コード入力が必要な場合
            this.$router.replace('/campaign/detail/code/' + this.campaignId);
          } else {
            //そのまま抽選
            //this.$router.replace('/campaign/result/'+this.campaignId);
            this.isLoad = true
            const userId = this.$store.state.userId;
            const userData = await getUser(userId);
            const callable = firebase.functions('asia-northeast1').httpsCallable('lottery');
            const request = {
              "lotteryId": this.campaignId,
              "userId": userId,
              "lineFootPrint": userData.lineFootPrint
            };
            const result = await callable(request)
              .catch(async e => {
                // TODO エラー
                //this.loading = false;
                //await this.alert("エラーが発生しました。" + (e?.message||""), true);
                this.isLoad = false

                console.log(e)
                throw e;
              });
            this.isLoad = false

            this.$router.replace({ path: '/campaign/result/' + this.campaignId, query: { obj: JSON.stringify(result) } });
          }
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoad = false
      }
    },
    backPage() {
      this.$router.push(`/campaign/list`);
    },
    getLotteryResult() {
      if (this.campaignResultList && this.campaignResultList.length > 0) {
        console.log(this.campaignResultList)
        return this.campaignResultList[0].lotteryResult
      }
      return 0
    }
  }
})
</script>
